<template>
  <div id="player"></div>
</template>

<script>
import polyvPlayer from 'polyvPlayer';
import queryString from 'query-string';
export default {
  name: 'HelloWorld',
  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);
    const {
      screenWidth,
      videoId,
      assignmentId,
      accessToken,
      videoStatus,
      needFullScreen,
    } = searchParams;
    const videoStatusNum = Number(videoStatus);
    const player = polyvPlayer({
      wrap: '#player',
      width: Number(screenWidth),
      height: (Number(screenWidth) * 480) / 854,
      vid: videoId,
      forceH5: true,
      allowFullscreen: true,
    });

    window.s2j_onPlayOver = () => {
      if (videoStatusNum < 2 && accessToken) {
        this.updateVideoStatus(2, assignmentId, accessToken);
      }
    };
    window.s2j_onPlayStart = () => {
      if (videoStatusNum < 2 && accessToken) {
        this.updateVideoStatus(1, assignmentId, accessToken);
      }
    };

    if (needFullScreen) {
      window.s2j_onFullScreen = (videoId) => {
        player.j2s_pauseVideo();
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              func: 'navigateToLandMode',
              start: player.j2s_getCurrentTime(),
              videoId,
            })
          );
        }
      };
    }
  },
  methods: {
    updateVideoStatus(status, assignmentId, accessToken) {
      this.axios({
        url: this.apiBaseUrl + 'DreamIT_TherapyAuth/UpdateMediaStatus',
        data: {
          MediaAssignmentID: assignmentId,
          MediaStatus: status,
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        method: 'POST',
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>
